import { render } from "./vote-page.vue?vue&type=template&id=2b2aa437&scoped=true"
import script from "./vote-page.vue?vue&type=script&lang=js"
export * from "./vote-page.vue?vue&type=script&lang=js"

import "./vote-page.vue?vue&type=style&index=0&id=2b2aa437&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2aa437"]])

export default __exports__